import { render, staticRenderFns } from "./BuyTab.vue?vue&type=template&id=b290f152&scoped=true&"
import script from "./BuyTab.vue?vue&type=script&lang=js&"
export * from "./BuyTab.vue?vue&type=script&lang=js&"
import style0 from "./BuyTab.vue?vue&type=style&index=0&id=b290f152&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b290f152",
  null
  
)

export default component.exports